import { apiRequest } from "./common";

const createWishList = async (data) => {
    const response = await apiRequest('post', '/student-college', data);
    return response.data;
};

const updateWishList = async (id, data) => {
    const response = await apiRequest('put', `/student-college/${id}`, data);
    return response.data;
};

const getWishListCollege = async (studentId) => {
    const response = await apiRequest('get', `/student-college/by-student/${studentId}`);
    return response.data;
};

const getCollegeList = async (studentId, pageNo, pageSize, searchText, filters) => {
    const response = await apiRequest('get', `/college?pageNo=${pageNo}&pageSize=${pageSize}&studentId=${studentId}&searchText=${searchText}&filters=${filters}`);
    return response.data;
};

const getAiSuggestCollege = async (studentId) => {
    const response = await apiRequest('get', `/college/${studentId}/ai-list?pageNo=1&pageSize=20`);
    return response.data;
};

const getDashboardColleges = async (studentId) => {
    const response = await apiRequest('get', `/college/${studentId}/dashboard`);
    return response.data;
};

const getCounsellingColleges  = async (studentId) => {
    const response = await apiRequest('get', `/college/${studentId}/target-safe`);
    return response.data;
};

export {
    createWishList,
    updateWishList,
    getWishListCollege,
    getCollegeList,
    getAiSuggestCollege,
    getDashboardColleges,
    getCounsellingColleges
}